import { uiActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    pathname: undefined,
};

export const reducer = createReducer(initialState, {
    [uiActions.changeRoute]: (state, action) => {
        state.pathname = action.payload;
    },
})